/* Seventeen Mirrors product page behaviour (Phase 2B): colour-filtered gallery, desktop arrows, animated accordions, sticky mobile add to cart, bundle row. v22 adds the LED "see it lit" tap (touch + click) that swaps the main image to the in-room glow shot. */
(function () {
  'use strict';
  if (window.__smProductLoaded) return;
  window.__smProductLoaded = true;

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); } else { document.addEventListener('DOMContentLoaded', fn); }
  }

  function getColourFromVariant(gallery, variant) {
    var idx = parseInt(gallery.dataset.smColourIndex || '0', 10);
    if (!idx || !variant) return '';
    return String(variant['option' + idx] || '').toLowerCase().trim();
  }

  function visibleSlides(gallery) {
    return Array.prototype.filter.call(
      gallery.querySelectorAll('.product__media-list .product__media-item'),
      function (li) { return !li.hasAttribute('data-sm-hide'); }
    );
  }

  function updateArrows(gallery) {
    var nav = gallery.querySelector('.sm-gal-nav');
    if (!nav) return;
    if (visibleSlides(gallery).length < 2) { nav.setAttribute('hidden', ''); } else { nav.removeAttribute('hidden'); }
  }

  function applyFilter(gallery, colour) {
    var c = (colour || '').toLowerCase().trim();
    /* Graceful fallback: while per-colour media sets are being equalised a
       colour can have no media of its own. Filtering to it would empty the
       gallery, so show the full set instead. */
    if (c && !gallery.querySelector('[data-sm-colour="' + c.replace(/"/g, '\\"') + '"]')) {
      c = '';
    }
    gallery.querySelectorAll('[data-sm-colour]').forEach(function (el) {
      var hide = c && el.dataset.smColour !== c;
      if (hide) { el.setAttribute('data-sm-hide', '1'); } else { el.removeAttribute('data-sm-hide'); }
    });
    ['GalleryViewer', 'GalleryThumbnails'].forEach(function (prefix) {
      var s = gallery.querySelector('[id^="' + prefix + '"]');
      if (s && typeof s.resetPages === 'function') { try { s.resetPages(); } catch (e) { /* noop */ } }
    });
    var active = gallery.querySelector('.product__media-item.is-active');
    if (!active || active.hasAttribute('data-sm-hide')) {
      var first = visibleSlides(gallery)[0];
      if (first && typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(first.dataset.mediaId, false);
      }
    }
    updateArrows(gallery);
  }

  function refilterFromDom() {
    var gallery = document.querySelector('media-gallery[data-sm-colour-index]');
    if (!gallery || gallery.dataset.smColourIndex === '0') return;
    var sel = document.querySelector('variant-selects [data-selected-variant]');
    if (!sel) return;
    var variant = null;
    try { variant = JSON.parse(sel.textContent); } catch (e) { return; }
    if (!variant) return;
    applyFilter(gallery, getColourFromVariant(gallery, variant));
  }

  function step(gallery, dir) {
    var slides = visibleSlides(gallery);
    if (slides.length < 2) return;
    var i = slides.findIndex(function (li) { return li.classList.contains('is-active'); });
    if (i < 0) i = 0;
    var next = slides[(i + dir + slides.length) % slides.length];
    if (next && typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(next.dataset.mediaId, false);
    }
  }

  function initGallery(gallery) {
    if (gallery.dataset.smInit) return;
    gallery.dataset.smInit = '1';
    var prev = gallery.querySelector('[data-sm-prev]');
    var next = gallery.querySelector('[data-sm-next]');
    if (prev) prev.addEventListener('click', function () { step(gallery, -1); });
    if (next) next.addEventListener('click', function () { step(gallery, 1); });
    updateArrows(gallery);
  }

  /* LED "see it lit" tap (v22). A touch + click control over the main image
     that swaps to the in-room glow shot, the same second image the desktop
     card hover reveals. Self-scoping: it only appears when a visible image's
     alt reads "glowing above/beside/in a ..." (the LED room shots), so it
     never shows on non-LED products or on the Copper LED, which has no room
     shot. There is no off-state photo, so "lit" means seen glowing in a room;
     "Studio view" returns to the white-background shot. Re-evaluated per
     colour, so it hides for any colour that has no room shot. */
  var SM_LIT_RE = /glowing\s+(above|beside|behind|across|through|over|by|in|at)\b/i;

  function initLit(gallery) {
    if (!gallery || gallery.dataset.smLitInit) return;
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;

    function altOf(li) { var img = li.querySelector('img'); return img ? (img.getAttribute('alt') || '') : ''; }
    function visItems() {
      return Array.prototype.filter.call(
        gallery.querySelectorAll('.product__media-list .product__media-item'),
        function (li) { return !li.hasAttribute('data-sm-hide'); }
      );
    }
    function litItem() {
      var items = visItems();
      for (var i = 0; i < items.length; i++) { if (SM_LIT_RE.test(altOf(items[i]))) return items[i]; }
      return null;
    }

    var anyLit = Array.prototype.some.call(
      gallery.querySelectorAll('.product__media-list .product__media-item'),
      function (li) { return SM_LIT_RE.test(altOf(li)); }
    );
    if (!anyLit) return;
    gallery.dataset.smLitInit = '1';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sm-lit';
    btn.setAttribute('data-sm-lit-btn', '');
    btn.setAttribute('aria-pressed', 'false');
    btn.hidden = true;
    btn.innerHTML = '<span class="sm-lit__glow" aria-hidden="true"></span><span class="sm-lit__label">See it lit</span>';
    viewer.appendChild(btn);
    var label = btn.querySelector('.sm-lit__label');

    function sync() {
      var lit = litItem();
      if (!lit) { btn.hidden = true; return; }
      btn.hidden = false;
      var onLit = lit.classList.contains('is-active');
      btn.classList.toggle('is-on', onLit);
      btn.setAttribute('aria-pressed', onLit ? 'true' : 'false');
      label.textContent = onLit ? 'Studio view' : 'See it lit';
    }

    btn.addEventListener('click', function () {
      var lit = litItem();
      if (!lit || typeof gallery.setActiveMedia !== 'function') return;
      var onLit = lit.classList.contains('is-active');
      var target = onLit ? visItems()[0] : lit;
      if (target) gallery.setActiveMedia(target.dataset.mediaId, false);
      setTimeout(sync, 40);
    });

    var t = null;
    var list = gallery.querySelector('.product__media-list') || gallery;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(sync, 50); })
      .observe(list, { attributes: true, subtree: true, attributeFilter: ['class', 'data-sm-hide'] });

    sync();
  }

  function initAccordions(root) {
    root.querySelectorAll('[data-sm-acc]').forEach(function (acc) {
      if (acc.dataset.smInit) return;
      acc.dataset.smInit = '1';
      acc.querySelectorAll('.sm-acc__head').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.sm-acc__item');
          var open = item.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    });
  }

  function initStickyAtc() {
    var bar = document.querySelector('[data-sm-satc]');
    if (!bar || bar.dataset.smInit) return;
    var main = document.querySelector(bar.dataset.smTarget);
    if (!main) return;
    bar.dataset.smInit = '1';
    var btn = bar.querySelector('[data-sm-satc-btn]');
    var priceOut = bar.querySelector('[data-sm-satc-price]');
    var priceSrc = bar.dataset.smPriceSrc ? document.querySelector(bar.dataset.smPriceSrc) : null;

    /* Pre-order PDPs: the theme's variant JS rewrites the main button label
       to variantStrings.addToCart on re-enable, which would silently drop
       the pre-order framing after a variant change. Keep the string true. */
    if (bar.dataset.smPreorder === '1' && window.variantStrings && window.variantStrings.addToCart) {
      window.variantStrings.addToCart = btn.textContent.trim() || 'Pre-order';
    }

    /* Mirror the main form: disabled state, label and live price. */
    var sync = function () {
      btn.disabled = main.disabled;
      var label = (main.textContent || '').trim();
      if (label) btn.textContent = label;
      if (priceOut && priceSrc) {
        var pEl = priceSrc.querySelector('.price-item--sale') || priceSrc.querySelector('.price-item--regular');
        if (pEl) {
          var pTxt = (pEl.textContent || '').trim();
          if (pTxt) priceOut.textContent = pTxt;
        }
      }
    };
    sync();
    new MutationObserver(sync).observe(main, { attributes: true, childList: true, subtree: true });
    if (priceSrc) {
      new MutationObserver(sync).observe(priceSrc, { childList: true, subtree: true, characterData: true });
    }
    btn.addEventListener('click', function () { main.click(); });
    /* While the main button is on screen the bar must be hidden AND
       non-focusable, so the hidden attribute is the source of truth. */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var below = !en.isIntersecting && en.boundingClientRect.top < 0;
        if (below) {
          if (bar.hidden) {
            bar.hidden = false;
            requestAnimationFrame(function () { bar.classList.add('is-visible'); });
          }
        } else {
          bar.classList.remove('is-visible');
          bar.hidden = true;
        }
      });
    }, { threshold: 0 });
    io.observe(main);
  }

  function initBundle() {
    var wrap = document.querySelector('[data-sm-bundle]');
    if (!wrap || wrap.dataset.smInit) return;
    wrap.dataset.smInit = '1';
    var btn = wrap.querySelector('[data-sm-add-both]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      btn.disabled = true;
      var old = btn.textContent;
      btn.textContent = 'Adding…';
      var fail = function () {
        btn.textContent = 'Could not add, please try again';
        btn.disabled = false;
        setTimeout(function () { btn.textContent = old; }, 3000);
      };
      try {
        var curInput = document.querySelector('form[data-type="add-to-cart-form"] input.product-variant-id');
        var cur = curInput ? parseInt(curInput.value, 10) : null;
        var pairData = JSON.parse(wrap.querySelector('[data-sm-pair-variants]').textContent);
        var colour = '';
        var gal = document.querySelector('media-gallery[data-sm-colour-index]');
        var sel = document.querySelector('variant-selects [data-selected-variant]');
        if (gal && sel) { try { colour = getColourFromVariant(gal, JSON.parse(sel.textContent)); } catch (e) { /* noop */ } }
        var pair = null;
        if (colour) {
          pair = pairData.find(function (v) { return v.available && v.colour && String(v.colour).toLowerCase() === colour; });
        }
        if (!pair) pair = pairData.find(function (v) { return v.available; }) || pairData[0];
        var items = [];
        if (cur) items.push({ id: cur, quantity: 1 });
        if (pair) items.push({ id: pair.id, quantity: 1 });
        if (items.length < 2) { fail(); return; }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = '/cart';
        }).catch(fail);
      } catch (e) { fail(); }
    });
  }

  var refilterTimer = null;
  function queueRefilter() {
    clearTimeout(refilterTimer);
    refilterTimer = setTimeout(refilterFromDom, 60);
  }

  function watchVariantChanges() {
    var info = document.querySelector('product-info');
    if (!info || info.dataset.smWatch) return;
    info.dataset.smWatch = '1';
    new MutationObserver(queueRefilter).observe(info, { childList: true, subtree: true });
  }

  function boot() {
    document.querySelectorAll('media-gallery').forEach(initGallery);
    document.querySelectorAll('media-gallery').forEach(initLit);
    initAccordions(document);
    initStickyAtc();
    initBundle();
    watchVariantChanges();
    refilterFromDom();
  }

  ready(boot);
  document.addEventListener('product-info:loaded', boot);

  try {
    var PSE = (typeof PUB_SUB_EVENTS !== 'undefined') ? PUB_SUB_EVENTS : window.PUB_SUB_EVENTS;
    var sub = (typeof subscribe === 'function') ? subscribe : window.subscribe;
    if (sub && PSE && PSE.variantChange) {
      sub(PSE.variantChange, function (event) {
        var gallery = document.querySelector('media-gallery[data-sm-colour-index]');
        if (!gallery) return;
        var variant = event && event.data ? event.data.variant : null;
        if (variant) { applyFilter(gallery, getColourFromVariant(gallery, variant)); } else { queueRefilter(); }
      });
    }
  } catch (e) { /* MutationObserver fallback covers it */ }
})();

/* -------------------------------------------------------------------------
   Seventeen Mirrors, CRO round 1, stream pdp-variants (v23).
   SIBLING LINK COLOUR SYNC. Appended block, deliberately self-contained:
   it does not touch the IIFE above, so applying or reverting it is a pure
   append or delete.

   THE PROBLEM IT SOLVES
   snippets/sm-size-siblings.liquid and snippets/sm-finish-siblings.liquid
   render their hrefs server side. Verified live on /products/sienna:
   tapping a colour pill updates the selected variant and the address bar
   but does NOT re-render the sibling row (the .sm-size DOM node survives
   the change). So the server-rendered ?variant= on those links goes stale
   the instant the shopper changes colour, and the customer is dropped onto
   the sibling product's default colour instead of the one they picked.
   This block rewrites the hrefs on every variant change.

   HOW IT KNOWS THE COLOUR
   The snippets emit data-sm-colour-pos on the row (the 1-based position of
   the option named Colour on THIS product) and data-sm-colour-map on each
   link ("matte black=56860772073632|brushed gold=...", colour values only).
   Position is read from the DOM rather than assumed, because option order
   differs between models. The map holds colour values only on purpose: a
   map of every option value would contain "Arch" and the size string, and
   a first-match lookup would return the wrong variant while looking like
   it worked.

   NO-OP BY DESIGN when no link carries data-sm-colour-map, which is every
   product whose siblings have a single colour, and every page that has not
   had the two snippets updated. Safe to ship ahead of them.
   ------------------------------------------------------------------------- */
(function () {
  'use strict';
  if (window.__smSiblingSyncLoaded) return;
  window.__smSiblingSyncLoaded = true;

  function readSelectedVariant() {
    var sel = document.querySelector('variant-selects [data-selected-variant]');
    if (!sel) return null;
    try { return JSON.parse(sel.textContent); } catch (e) { return null; }
  }

  function colourOf(variant) {
    if (!variant) return '';
    var row = document.querySelector('.sm-size[data-sm-colour-pos]');
    if (!row) return '';
    var pos = parseInt(row.getAttribute('data-sm-colour-pos'), 10);
    if (!pos) return '';
    var val = variant['option' + pos];
    return val ? String(val).trim() : '';
  }

  function lookup(map, key) {
    var parts = map.split('|');
    for (var i = 0; i < parts.length; i++) {
      if (!parts[i]) continue;
      var eq = parts[i].lastIndexOf('=');
      if (eq < 1) continue;
      if (parts[i].slice(0, eq) === key) return parts[i].slice(eq + 1);
    }
    return '';
  }

  function syncSiblingLinks(variant) {
    var links = document.querySelectorAll('a.sm-size__btn[data-sm-colour-map]');
    if (!links.length) return;

    if (!variant) variant = readSelectedVariant();
    var colour = colourOf(variant);
    if (!colour) return;
    var key = colour.toLowerCase();

    Array.prototype.forEach.call(links, function (a) {
      var base = a.getAttribute('data-sm-sib-url') || a.getAttribute('href') || '';
      var id = lookup(a.getAttribute('data-sm-colour-map') || '', key);

      a.setAttribute('href', id ? base + '?variant=' + id : base);

      var note = a.querySelector('.sm-size__note');
      if (!note) return;
      if (id) {
        note.hidden = true;
        a.removeAttribute('aria-label');
      } else {
        note.hidden = false;
        var strong = a.querySelector('strong');
        var price = a.querySelector('.sm-size__price');
        var label = (strong ? strong.textContent.trim() : '');
        if (price) label += ', ' + price.textContent.trim();
        var kind = a.closest('.sm-finish') ? 'finish' : 'size';
        a.setAttribute('aria-label', label + ', ' + colour + ' is not available in this ' + kind);
      }
    });
  }

  var smSibTimer = null;
  function queueSync() {
    clearTimeout(smSibTimer);
    smSibTimer = setTimeout(function () { syncSiblingLinks(null); }, 60);
  }

  function smSibBoot() {
    syncSiblingLinks(null);
    var info = document.querySelector('product-info');
    if (info && !info.dataset.smSibWatch) {
      info.dataset.smSibWatch = '1';
      new MutationObserver(queueSync).observe(info, { childList: true, subtree: true });
    }
  }

  if (document.readyState !== 'loading') {
    smSibBoot();
  } else {
    document.addEventListener('DOMContentLoaded', smSibBoot);
  }
  document.addEventListener('product-info:loaded', smSibBoot);

  try {
    var PSE = (typeof PUB_SUB_EVENTS !== 'undefined') ? PUB_SUB_EVENTS : window.PUB_SUB_EVENTS;
    var sub = (typeof subscribe === 'function') ? subscribe : window.subscribe;
    if (sub && PSE && PSE.variantChange) {
      sub(PSE.variantChange, function (event) {
        var variant = event && event.data ? event.data.variant : null;
        if (variant) { syncSiblingLinks(variant); } else { queueSync(); }
      });
    }
  } catch (e) { /* the MutationObserver above is the fallback */ }
})();
